import { useRef, useEffect } from "react";
// If you kick off a long-ish-running async (e.g api) call, when the call comes back
//  the component may have been unmounted.  If you proceed to do e.g. setState(newValue)
//  on the unmounted component you get errors in the console and warnings about potential
//  memory leaks. By having a hook that lets you know if unmounting has occurred, we
//  stop the problem.
//  https://stackoverflow.com/a/59956926
export const useIsMounted = () => {
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
